import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';

import { Box, Button, Typography } from '@mui/material';

import { paths } from 'src/routes/paths';

export function UsrDetails() {
  const { comboId, coverageId, policyId, reportNumber, correctionSequenceNumber } = useParams<{
    comboId: string;
    coverageId: string;
    policyId: string;
    reportNumber: string;
    correctionSequenceNumber: string;
  }>();
  const navigate = useNavigate();

const hasRequiredParams = Boolean(
  comboId && coverageId && policyId &&
  reportNumber && /^\d+$/.test(reportNumber) &&
  correctionSequenceNumber !== undefined && /^\d+$/.test(correctionSequenceNumber)
);
  useEffect(() => {
    if (hasRequiredParams) {
      navigate(paths.dashboard.employer_data.policy_details(comboId!, coverageId!, policyId!), {
        state: {
          tab: 'unitStatReports',
          reportNumber,
          correctionSequenceNumber,
        },
        replace: true,
      });
    }
  }, [comboId, coverageId, policyId, reportNumber, correctionSequenceNumber, navigate, hasRequiredParams]);

  if (!hasRequiredParams) {
    const transactionHistoryPath =
      comboId && coverageId && policyId
        ? paths.dashboard.employer_data.policy_details(comboId, coverageId, policyId)
        : null;

    return (
      <Box sx={{ py: 5, px: 3 }} data-testid="usr-details-error">
        <Typography variant="h5" sx={{ mb: 2 }} data-testid="usr-details-error-message">
          USR report not found
        </Typography>
        <Button
          variant="text"
          onClick={() =>
            transactionHistoryPath
              ? navigate(transactionHistoryPath, {
                  state: { tab: 'transactionHistory' },
                })
              : navigate(-1)
          }
          data-testid="usr-details-fallback-link"
        >
          Back to transaction history
        </Button>
      </Box>
    );
  }

  return null;
}
